import request from '../../libs/request';

export default {
  geocode: (queryParams) => request('maps/api/geocode/json', 'https://maps.googleapis.com/').get({ queryParams }),
};
